<template>
  <div class="modal-mask animate__animated" @keydown.esc="emit('close')">
    <section
      ref="modal"
      class="modal-profile !h-auto !w-auto relative"
      :class="type"
      @keydown.esc="emit('close')"
      @scroll="handleScroll()"
    >
      <header
        class="flex justify-between pb-9 sticky top-0 z-[1] bg-black pt-7"
      >
        <h1 class="wp-title">
          {{ title }}
        </h1>
        <w-icon
          class="cursor-pointer"
          :img="require('@/assets/images/modal-cross.png')"
          style="height: 15px; width: 15px;"
          @click="$emit('close')"
        />
      </header>
      <main id="main-modal" class="modal-content gap-3">
        <slot name="modalProfile" />
        <div ref="endOfPage"></div>
      </main>
      <div v-if="gradient" class="gradient scroll"></div>
    </section>
  </div>
</template>

<script setup>
import { ref, toRefs } from "vue";
import WIcon from "@/components/general/ui/elements/WIcon.vue";

const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: ""
  },
  gradient: {
    type: Boolean,
    default: false
  },
  page: {
    type: Number,
    default: 1
  },
  totalItems: {
    type: Number,
    default: 1
  },
  itemsPerPage: {
    type: Number,
    default: 1
  }
  // types { small(), medium(), big(), large(width: 1025px, height: 429px), tall()}
});
const { page, itemsPerPage, totalItems } = toRefs(props);
const emit = defineEmits(["close", "nextPage"]);
const modal = ref(null);
const handleScroll = () => {
  if (modal.value) {
    const content = modal.value.querySelector("#main-modal");
    if (
      content.scrollHeight - content.scrollTop >
      content.clientHeight + content.scrollThreshold
    ) {
    }
    if (totalItems.value / itemsPerPage.value >= page.value) {
      emit("nextPage", page.value++);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/mixins/delete-scroll.scss";
.modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  @include delete-scroll;
}
.modal-profile {
  max-height: 500px;
  min-height: 340px;
  position: relative;
  background-color: $eventWidgetCard;
  border-radius: 5px;
  z-index: 20;
  animation: fadeInDown 0.5s ease;
  margin: auto;
  @media screen and (max-width: $screen-xl) {
    width: 90%;
    // top: 20vh;
  }
  header {
    padding-left: 12px;
    padding-right: 12px;
    @media screen and (min-width: $screen-md) {
      padding: 2rem 32px;
    }
  }
  main {
    padding: 5px 12px;
    @media screen and (min-width: $screen-md) {
      padding: 0 32px;
    }
  }
  .wp-title {
    font-size: 20px;
  }
  @include delete-scroll;
  &.medium {
    width: 956px;
    height: auto;
    @media screen and (max-width: $screen-xl) {
      width: 100%;
      height: 70vh;
    }
    @media screen and (max-width: $screen-md) {
      padding: 0 10px;
    }
  }
  &.modal-large {
    width: 1025px;
    height: 429px;
    .modal-content {
      display: grid;
      grid-template-columns: repeat(3, 100px);
      grid-auto-rows: auto;
      @media screen and (min-width: $screen-xs) {
        grid-template-columns: repeat(2, 203px);
      }
      @media screen and (min-width: $screen-sm) {
        grid-template-columns: repeat(3, 203px);
      }
      @media screen and (min-width: $screen-lg) {
        grid-template-columns: repeat(4, 203px);
        padding: 24px 74px 55px 61px;
      }
    }
  }
}
.gradient {
  background: linear-gradient(
    180deg,
    rgba(181, 181, 181, 0) 65%,
    $backgroundBlack 100%
  );
  width: 100%;
  pointer-events: none;
  z-index: 2;
  height: 36vh;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -12px;
  @media screen and (min-width: $screen-md) {
    bottom: -3px;
  }
  &.scroll {
    position: sticky;
  }
}
</style>
